export default {
	TEMPLATES_PREVIEW_ACCOUNT: 56690,
	TEMPLATES_PREVIEW_USER: 50374,
	PLAYBOOKS_PREVIEW_ACCOUNT: 142687,
	PLAYBOOKS_PREVIEW_USER: 130236,
};
